module.exports = __webpack_public_path__ + "static/media/human-advantage-provider.1f693571.svg";